import AboutPic from './AboutPic'

function IntroBio() {
    return (
      <div className="text-left">
        <h2 className="bottom-line">About Alex</h2>
        <AboutPic className="about-pic"/>
        <p>Alex Floyd is a multi-instrumentalist (guitar, piano, organ, bass, drums) and singer from Long Island, NY. He plays hits from all decades in a variety of genres, including rock &amp; roll, modern pop, country, and the blues, and was strongly influenced by the sound of MTV's "Unplugged" series. Alex combined his musical ability with his background in IT to bring audiences a true one-man band show.</p>
      </div>
    );
  }
  
  export default IntroBio;